import { http } from '@/utils/http/axios';

const BASE_URL = import.meta.env.VITE_HEPS_API_BASE_URL;
// console.log('DEBUG => ', BASE_URL);

export interface BasicResponseModel<T = any> {
  code: number;
  message: string;
  result: T;
}

export interface BasicPageParams {
  pageNumber: number;
  pageSize: number;
  total: number;
}

/**
 * @description: 获取用户信息
 */
export function getUserInfo(params) {
  return http.request({
    // url: '/admin_info',
    url: BASE_URL + '/api/user_info',
    method: 'GET',
    params,
  });
}

/**
 * @description: 用户登录
 */
export function login(params) {
  return http.request<BasicResponseModel>(
    {
      // url: '/login',
      url: BASE_URL + '/login',
      method: 'POST',
      params,
    },
    {
      isTransformResponse: false,
    }
  );
}
